import { useState } from "react";
import Input from "../common/Input";
import Button from "../common/Button";
import { createDesignation } from "../../../services/designationServices";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router";

const AddDesignation = () => {
  const [designationName, setDesignationName] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    const data = {
      name: designationName,
    };

    try {
      setLoading(true);
      const result = await createDesignation(data);
      toast.success("Designation added successfully!");
      setDesignationName("");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setDesignationName("");
  };

  return (
    <div className="max-w-md p-6 bg-[#F5F0FF] rounded-lg space-y-4 font-sans">
      <Input
        label="Designation name"
        value={designationName}
        onChange={setDesignationName}
        placeholder="Enter designation name"
        required
      />

      <div className="pt-2 space-y-2">
        <Button
          onClick={handleSubmit}
          variant="primary"
          className="w-full"
          disabled={loading}
        >
          {loading ? "Adding..." : "Confirm & Add Designation"}
        </Button>

        <Button onClick={handleCancel} variant="text" className="w-full">
          Clear
        </Button>
      </div>
    </div>
  );
};

export default AddDesignation;
